import React from "react";

const Country = React.lazy(() => import("./Country"));
const CreateCountry = React.lazy(() => import("./Country/CreateCountry"));
const Region = React.lazy(() => import("./Region"));
const CreateRegion = React.lazy(() => import("./Region/CreateRegion"));
const City = React.lazy(() => import("./City"));
const CreateCity = React.lazy(() => import("./City/CreateCity"));
const AddressType = React.lazy(() => import("./AddressType"));
const CreateAddressType = React.lazy(() =>
  import("./AddressType/CreateAddressType")
);
const ProductType = React.lazy(() => import("./ProductType"));
const CreateProductType = React.lazy(() =>
  import("./ProductType/CreateProductType")
);
const DesignationType = React.lazy(() => import("./DesignationType"));
const CreateDesignationType = React.lazy(() =>
  import("./DesignationType/CreateDesignationType")
);
const DiseaseType = React.lazy(() => import("./DiseaseType"));
const CreateDiseaseType = React.lazy(() =>
  import("./DiseaseType/CreateDiseaseType")
);
const PackageDurationType = React.lazy(() => import("./PackageDurationType"));
const CreatePackageDurationType = React.lazy(() =>
  import("./PackageDurationType/CreatePackageDurationType")
);
const PaymentType = React.lazy(() => import("./PaymentType"));

const Uom = React.lazy(() => import("./Uom"));
const CreateUom = React.lazy(() => import("./Uom/CreateUom"));

export const coreDataRoutes = [
  {
    path: "/admin/setting/coreData/uom",
    name: "Uom",
    element: <Uom />,
  },
  {
    path: "/admin/setting/coreData/uom/create",
    name: "Create Uom",
    element: <CreateUom />,
  },
  {
    path: "/admin/setting/coreData/uom/update/:id",
    name: "Update Uom",
    element: <CreateUom />,
  },
  {
    path: "/admin/setting/coreData/country",
    name: "Country",
    element: <Country />,
  },
  {
    path: "/admin/setting/coreData/country/create",
    name: "Create Country",
    element: <CreateCountry />,
  },
  {
    path: "/admin/setting/coreData/country/update/:id?",
    name: "Create Country",
    element: <CreateCountry />,
  },
  {
    path: "/admin/setting/coreData/region",
    name: "Region",
    element: <Region />,
  },
  {
    path: "/admin/setting/coreData/region/update/:id?",
    name: "Create Region",
    element: <CreateRegion />,
  },
  {
    path: "/admin/setting/coreData/region/create",
    name: "Create Region",
    element: <CreateRegion />,
  },
  {
    path: "/admin/setting/coreData/city",
    name: "City",
    element: <City />,
  },
  {
    path: "/admin/setting/coreData/city/create",
    name: "Create City",
    element: <CreateCity />,
  },
  {
    path: "/admin/setting/coreData/city/update/:id?",
    name: "Create City",
    element: <CreateCity />,
  },
  {
    path: "/admin/setting/coreData/addressType",
    name: "AddressType",
    element: <AddressType />,
  },
  {
    path: "/admin/setting/coreData/addressType/create",
    name: "Create AddressType",
    element: <CreateAddressType />,
  },
  {
    path: "/admin/setting/coreData/addressType/update/:id",
    name: "Create AddressType",
    element: <CreateAddressType />,
  },
  {
    path: "/admin/setting/coreData/productType",
    name: "ProductType",
    element: <ProductType />,
  },
  {
    path: "/admin/setting/coreData/productType/create",
    name: "Create ProductType",
    element: <CreateProductType />,
  },
  {
    path: "/admin/setting/coreData/productType/update/:id?",
    name: "Create ProductType",
    element: <CreateProductType />,
  },
  {
    path: "/admin/setting/coreData/designationType",
    name: "DesignationType",
    element: <DesignationType />,
  },
  {
    path: "/admin/setting/coreData/designationType/create/:id?",
    name: "Create Designation Type",
    element: <CreateDesignationType />,
  },
  {
    path: "/admin/setting/coreData/designationType/update/:id?",
    name: "Create Designation Type",
    element: <CreateDesignationType />,
  },
  {
    path: "/admin/setting/coreData/diseaseType",
    name: "DiseaseType",
    element: <DiseaseType />,
  },
  {
    path: "/admin/setting/coreData/diseaseType/create",
    name: "Create Designation Type",
    element: <CreateDiseaseType />,
  },
  {
    path: "/admin/setting/coreData/diseaseType/update/:id?",
    name: "Create Designation Type",
    element: <CreateDiseaseType />,
  },
  {
    path: "/admin/setting/coreData/packageDurationType",
    name: "PackageDurationType",
    element: <PackageDurationType />,
  },
  {
    path: "/admin/setting/coreData/packageDurationType/create",
    name: "Create Package Duration Type",
    element: <CreatePackageDurationType />,
  },
  {
    path: "/admin/setting/coreData/packageDurationType/update/:id?",
    name: "Create Package Duration Type",
    element: <CreatePackageDurationType />,
  },
  {
    path: "/admin/setting/coreData/paymentType",
    name: "PaymentType",
    element: <PaymentType />,
  },
];
